class FrontpageController {
    constructor($timeout,$scope) {
        "ngInject";
        this.$timeout=$timeout;
        this.$scope=$scope;
        this.$onDestroy = function () {
            this.$timeout.cancel(this.$scope.timer)
        }; 
        $scope.slides = [0, 1, 2, 3, 4]
        $scope.carousel = {
            index: 0
        }
    }
    $onInit(){

    }

}

export default FrontpageController;



// WEBPACK FOOTER //
// ./src/app/components/face/index/frontpage/frontpage.controller.js